/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import * as Sentry from '@sentry/react';

import logger from 'js/app/loggerSingleton';

import { Typography2 } from '@coursera/cds-core';

import { currencyCodeMap } from 'bundles/payments/lib/currencies';

const styles = {
  wrapper: css`
    display: flex;
    align-items: flex-end;
  `,
  container: css`
    display: flex;
    align-items: flex-start;
  `,
  currencyCode: css`
    font-weight: 600;
    transform: translate(0, 3px);
  `,
  subscriptionCadence: css`
    transform: translate(0, -5px);
  `,
};

export type Props = {
  amount: number;
  currencyCode: string;
  subscriptionCadence: string;
};

const PriceWithSuperScriptCurrency = ({ amount, currencyCode, subscriptionCadence }: Props) => {
  let currencyToDisplay;
  const currencyCodeObj = currencyCodeMap[currencyCode];
  if (currencyCode === 'CAD') {
    // we want currency in Canada to be displayed as 'CA$'
    currencyToDisplay = 'CA$';
  } else if (currencyCodeObj) {
    currencyToDisplay = currencyCodeObj.symbol;
  } else {
    // default to USD but log it
    currencyToDisplay = '$';
    logger.error(`Unsupported currency code: ${currencyCode}`);
    Sentry.captureException(`Unsupported currency code: ${currencyCode}`);
  }

  return (
    <div css={styles.wrapper}>
      <span css={styles.container}>
        <Typography2 component="span" variant="actionPrimary" css={styles.currencyCode}>
          {currencyToDisplay}
        </Typography2>
        <Typography2 variant="titleMedium" component="span">
          {amount}
        </Typography2>
      </span>
      <Typography2 variant="subtitleMedium" component="span" css={styles.subscriptionCadence}>
        {subscriptionCadence}
      </Typography2>
    </div>
  );
};

export default PriceWithSuperScriptCurrency;
